import { URLS, createJurisdictionHeaders } from '@/data';
import { useQuery } from '@tanstack/react-query';

import { GameListResponse } from './use-casino-games';

type CasinoGameHistoryResponse = {
    data: {
        games: Array<{
            round_id: string;
            game_id: string;
            game_name: string;
            played_at: string;
        }>;
    };
};

/* 
    Get the user's recently played game history.
*/
const getCasinoGameHistory = async (): Promise<CasinoGameHistoryResponse> => {
    const response = await fetch(`${URLS.CHAMELON_API_URL}/auth/casino/game-history`, {
        method: 'GET',
        headers: {
            ...createJurisdictionHeaders(),
            JURISDICTION: 'CASH-CASINO',
            'Content-Type': 'application/json',
        },
    });
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    return response.json();
};

/* Get casino games by game id */
export const getCasinoGamesByIds = async (
    gameIds: string[],
    selectedCountryCode: string = 'all'
): Promise<GameListResponse> => {
    if (gameIds.length === 0) {
        return { count: 0, total: 0, items: [] };
    }

    const filterString = gameIds.map(id => `id=${id}`).join(',');
    const response = await fetch(
        `${URLS.CASINO_GAMES_API_URL}/v2/casino-new/games?Filter=${filterString}&SelectedCountryCode=${selectedCountryCode}`,
        {
            method: 'GET',
        }
    );
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    return response.json();
};

export const useCasinoGameHistory = () => {
    return useQuery({
        queryKey: ['casino-game-history'],
        queryFn: () => getCasinoGameHistory(),
    });
};
